import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IApp } from '@core/models/app.interfaces';
import { UploadDocumentService } from '@shared/services/upload-document.service';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Account } from '@core/models/account.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { ModalService } from '@shared/services/modal.service';
import { SereviceMessageType, DEFAULT_DIALOG_CONFIG } from '@core/constants/serviceMessage.const';
import { TableNewRowComponent } from '@shared/components/table-new-row/table-new-row.component';
import { FormGroup, FormsModule } from '@angular/forms';
import { TABLE_NEW_ROW_ACTION, TableNewRow } from '@shared/models/table-new-row.model';
import { Router } from '@angular/router';
import { ITableViewConfig } from '@shared/models/table-view.model';
import { accountRespondConfig } from '@module/account-management/account-management.const';
import { BaseActionsComponent } from "@shared/components/base-actions/base-actions.component";
import { HelperService } from "@shared/services/helper.service";
import { RecognizedUnitService } from '@module/obligation-management/services/recognized-unit.service';
import { RecognizedUnitInvalidateComponent } from '@module/obligation-management/controls/recognized-unit-invalidate/recognized-unit-invalidate.component';
import { craPaymentsTableConfig , offsetsPaymentsTableConfig, craNotesConfig} from '@module/program-management/program-management.const';
import { StoreService } from '@core/store/store.service';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { CommonModule } from '@angular/common';
const COMPONENT_ID = 'EEC_RESULT_FORM';

export const actionUriMap : any ={
  'CANCEL' :'cancelITP',
  'ITP_CANCEL' :'cancelITP',
  'APPROVE': '/approve',
  'REJECT':'/reject',
  'SUBMIT_REVERSAL':'reversePayment',
  'RESUBMIT':'reSubmitPaymentReversal',
 }

 const uriPrefix = '/obps-service/transaction';

@Component({
  selector: 'app-excess-emission-charge-actions',
  templateUrl: './excess-emission-charge-actions.component.html',
  styleUrls: ['./excess-emission-charge-actions.component.scss'],
  imports: [NgSelectModule, WCAGLabelDirective, TranslateModule, CommonModule, FormsModule]
})
export class ExcessEmissionChargeActionsComponent  extends BaseActionsComponent
implements OnInit {
@Input() actionsList: IApp.IEntityAction[];
@Input() remittanceData: any;
@Input() quantity: number;
@Input() appendTo: string;
@Output() actionSuccessfull = new EventEmitter<boolean>();

tableConfig: ITableViewConfig;

constructor(
  private uploadDocumentService: UploadDocumentService,
  private modalService: ModalService,
  private router: Router,
  private helperService: HelperService,
  private recognizedUnitService: RecognizedUnitService,
  private store: StoreService,

) {
  super();
}

ngOnInit() {
  this.tableConfig = accountRespondConfig;
  this.setActions();
}

setActions() {
  if (this.actionsList) {
    const actionsList = JSON.parse(JSON.stringify(this.actionsList));
    actionsList.forEach(
      option =>
        (option.label = this.translateService.instant(
          `COMMON.actionsLabel.${this.eecAction(option.workflowAction)}`,
        )),
    );
    this.actionsList = actionsList.sort((a, b) => a.label.localeCompare(b.label));
  }
}

private eecAction(action) {
  switch (action) {
    case 'VIEW_58REPORT':
      return 'VIEW_58REPORT_EEC';
    case 'DOWNLOAD_58REPORT':
      return 'DOWNLOAD_58REPORT_EEC';
    default:
      return action;
  }
}

triggerActionController(value: IApp.IEntityAction): void {
  this.resetSelection();
  switch (value.workflowAction) {
    case "EDIT":
    case "APPROVE":
    case "REJECT":
    case "RESUBMIT_FORM":
    this.openEditPopUp(this.remittanceData);
      break;
    case "ADD_NOTE":
      this.openNotesPopUp();
      break;
    case "VIEW_58REPORT":
      this.router.navigate(
        this.helperService.getTranslatedPath(
          `/obligation-management/section58/EEC/${this.remittanceData.sec58reportId}`
        )
      );
      break;
    case "DOWNLOAD_58REPORT":
      this.uploadDocumentService.downloadRequestJsonPdf(this.remittanceData.sec58reportId,
        this.translateService.instant('Section58ReportPdf.EecPayment.reportTitle'));
      break;
    case "VIEW_ITP":
      this.router.navigate(
        this.helperService.getTranslatedPath(
          `/obligation-management/view/eec/${this.remittanceData.obligationId}/${this.remittanceData.id}`
        ),
        { state: { data: this.remittanceData } }
      );
      break;
    case "SUBMIT_SEC58_REPORT":
      this.submit();
      break;
    case "SUBMIT_REFUND":
      this.submitRefund("refund");
      break;
    case "VIEW_REFUND_REQUEST":
      this.uploadDocumentService.viewRefundReuestById(this.remittanceData.paymentRefundId);
      break;
    default:
      let metaData = value.label;
      if (value.workflowAction === 'ITP_CANCEL') { // IF ITP_CANCEL, then change the metaData to CANCEL action label
        metaData = 'CANCEL';
      }
      this.modalService
        .open(
          ServiceMessageComponent,
          {
            messages: null,
            message: 'confirmationMessage',
            metaData,
            type: SereviceMessageType.WARNING,
          },
          true,
          DEFAULT_DIALOG_CONFIG,
        )
        .afterClosed()
        .subscribe((result?: any) => {
          if (result) {
            this.executeAction(value);
          }
          this.resetSelection();
        });
      break;
  }
}

submitRefund(uri: string){
  this.router.navigate(
    this.helperService.getTranslatedPath(
      `/obligation-management/${uri}/eec/${this.remittanceData.obligationId}/${this.remittanceData.id}`
    ),
    { state: { data: this.remittanceData } }
  );
}

submit(){
  this.router.navigate(
    this.helperService.getTranslatedPath(
      `/obligation-management/remittance/EEC/${this.remittanceData.obligationId}/${this.remittanceData.id}`
    ),
    { state: { data: this.remittanceData } }
  );
}


openEditPopUp(rowData){
  const tableConfig = this.store.user.isOffset() ? offsetsPaymentsTableConfig : craPaymentsTableConfig;;

  let tableRow = {
    form: tableConfig,
    defaultValues: rowData,
    actionType:TABLE_NEW_ROW_ACTION.EDIT
  } as TableNewRow;
  tableRow.buttons = this.validateButtonList(rowData);
  if(rowData.status === 'COMPLETE'){
    tableRow.validate = true;

  }

  this.modalService.open(TableNewRowComponent, tableRow as TableNewRow).afterClosed().subscribe((result?: any) => {
    if (result) {
      this.actionSuccessfull.emit(true);
    }
  });
}

validateButtonList(rowData){
  let buttons=[];
  this.actionsList.map(action =>{

    if(action.workflowAction === 'APPROVE'){
      buttons.push({
        label : 'COMMON.actionsLabel.APPROVE',
        actionUri : `${uriPrefix}${actionUriMap['APPROVE']}`,
        id: COMPONENT_ID + '_approveBtn',
      })
    }else if(action.workflowAction === 'REJECT'){
      buttons.push({
        label : 'COMMON.actionsLabel.REJECT',
        actionUri : `${uriPrefix}${actionUriMap['REJECT']}`,
        id: COMPONENT_ID + '_rejectBtn',
      })
    }

    if(rowData.status === 'COMPLETE'){
      if(action.workflowAction === 'SUBMIT_REVERSAL'){
        buttons.push({
          label : 'COMMON.actionsLabel.SUBMIT_REVERSAL',
          actionUri : `${uriPrefix}/${actionUriMap['SUBMIT_REVERSAL']}`,
          id: COMPONENT_ID + '_submitReversalBtn',
        })
      }
    }
});
return buttons;
}

openNotesPopUp() {
  const respondModel: IApp.ICreditActionData = {};
  respondModel.id =  this.remittanceData.id;
  respondModel.notes = this.remittanceData.notes;
  this.modalService.open(TableNewRowComponent, { form: craNotesConfig, defaultValues: respondModel, actionType: TABLE_NEW_ROW_ACTION.EDIT } as TableNewRow).afterClosed().subscribe((result?: any) => {
    if (result) {
      this.actionSuccessfull.emit(true);
    }
  });
}

public executeAction(value: IApp.IEntityAction): void {
  const creditActionData: IApp.ICreditActionData = {
    id : this.remittanceData.id
  };
   this.doRuAction(actionUriMap[value.workflowAction],creditActionData );
}

doRuAction(uri: string, creditActionData: IApp.ICreditActionData) {
  this.recognizedUnitService
    .doRuAction(`/transaction/${uri}`, creditActionData)
    .pipe(takeUntil(this._destroy$))
    .subscribe((value) => {
      this.actionSuccessfull.emit(true);
    });
}

openInvalidForm(data){

  this.modalService.open(RecognizedUnitInvalidateComponent, data ).afterClosed().subscribe((result?: any) => {
    if (result) {

    }
  });
}
}
